import { Component } from '@angular/core';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'ms-dashboard-select-org-prompt',
	imports: [FaDuotoneIconComponent],
	templateUrl: './dashboard-select-org-prompt.component.html',
	styleUrl: './dashboard-select-org-prompt.component.scss'
})
export class DashboardSelectOrgPromptComponent {}
